document.addEventListener('readystatechange', event => {
    let header = document.querySelector("header[role='banner']");
    let error = document.querySelector("header .header--inner div[data-drupal-messages]");
    let btnContinuarStep1 = document.querySelector(".step-1.btn-continuar input");
    let condiciones = document.querySelector(".js-form-item-conditions");
    let formUpdate = document.querySelector(".data-update-form");
    let select = document.querySelector(".form-select");
    let input = document.querySelector(".form-text")

    if(event.target.readyState === "complete") {
        if(error != null) {
            header.classList.add("error");
        }
        else {
            header.classList.remove("error");
        }
    }

    if (formUpdate != null && condiciones != null) {    
        let inputCheckCondiciones = document.querySelector(".js-form-item-conditions");
        btnContinuarStep1.addEventListener("mousedown", (e)=>{
            if(!condiciones.classList.contains('js-checked') && condiciones != null){
                condiciones.parentElement.classList.add('not-checked');
                formUpdate.classList.add('not-checked');
                inputCheckCondiciones.setAttribute('required', 'required');
                // e.stopImmediatePropagation();
                // e.preventDefault();
            }else{
                formUpdate.classList.remove('not-checked');
                condiciones.classList.remove('not-checked')
            }
            if(select.value == 2 && input.value.length === 9){
                input.classList.remove("valid");
                input.parentElement.classList.add("error-9");
                input.classList.add("error");
                e.stopImmediatePropagation();
            }else{
                input.parentElement.classList.remove("error-9");
            }
        })
    }

});
